import { useAppSelector } from '@/hooks/redux-hooks';

type DataHubUserConfig = {
  timezoneLabel: string;
  timezoneValue: string;
  dateFormatValue: string;
};

export const useDataHubUserConfig = (): DataHubUserConfig => {
  return useAppSelector(state => ({
    timezoneLabel: state.userConfig.userConfig.timezone.label,
    timezoneValue: state.userConfig.userConfig.timezone.value,
    dateFormatValue: state.userConfig.userConfig.dateFormat.value
  }));
};
